export enum PAGES { 
    HOME = 'home',
    TRADE = 'trade'
}
